import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="p-5 text-center" style={{ minHeight: '50vh' }}>
      <h1 className="h3 mb-3">Page not found</h1>
      <p className="text-muted mb-4">The page you requested does not exist or was moved.</p>
      <Button variant="primary" onClick={() => navigate(-1)}>Go back</Button>
    </div>
  );
}
